{
  "version": 1,
  "asset_id": "d23a0904-359e-4cf5-a3d7-caeb09255064",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/d23a0904-359e-4cf5-a3d7-caeb09255064/ss01-card-n4.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/d23a0904-359e-4cf5-a3d7-caeb09255064/ss01-card-n4.webp",
  "original_filename": "ss01-card-n4.webp",
  "size": 106400,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:37Z"
}
